import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import styled from "styled-components";
import Login from "../components/Login.js";
import img from '../assets/hexagon-bg.png';
import logo from '../assets/logo@2x.png';
import sanityClient from "../client.js";

const { clamp } = require('../assets/methods.js');

const Home = (props) => {
    const [currentMonth, setMonth] = useState(8);
    const [feedData, setFeed] = useState(null);

    useEffect(() => {
        sanityClient
            .fetch(
                `*[_type == "post" && month == ${currentMonth}] | order(publishedAt) {
        _id,
        title,
        slug,
        publishedAt,
        month,
        tag,
        mainImage{
          asset->{
          _id,
          url
        }
      }
    }`
            )
            .then((data) => setFeed(data))
            .catch(console.error);
    }, [currentMonth]);

    const parseDate = (dateString) => {
        var date = new Date(dateString);
        var dateNumber = date.getDate();
        return dateNumber;
    }

    const prevMonth = () => {
        var newMonth = currentMonth - 1;
        setMonth(clamp(newMonth, 1, 12));
    }

    const nextMonth = () => {
        var newMonth = currentMonth + 1;
        setMonth(clamp(newMonth, 1, 12));
    }

    const parseMonthName = (monthNumber) => {
        var monthName = "Snozvember";

        switch (monthNumber) {
            case 1: monthName = "JAN";
                break;
            case 2: monthName = "FEB";
                break;
            case 3: monthName = "MAR";
                break;
            case 4: monthName = "APR";
                break;
            case 5: monthName = "MAY";
                break;
            case 6: monthName = "JUN";
                break;
            case 7: monthName = "JUL";
                break;
            case 8: monthName = "AUG";
                break;
            case 9: monthName = "SEP";
                break;
            case 10: monthName = "OCT";
                break;
            case 11: monthName = "NOV";
                break;
            case 12: monthName = "DEC";
                break;
            default: monthName = "snoz";
                break;
        }
        return monthName;
    }

    return (
        <div>
            <FeedContainer>
                <img className="logo" src={logo} alt="logo" />
                <MonthSwitcher>
                    <button onClick={() => prevMonth()}>
                        &lt;
                </button>
                    <Title>{parseMonthName(currentMonth)}</Title>
                    <button onClick={() => nextMonth()}>
                        &gt;
                </button>
                </MonthSwitcher>
                <Login
                    isLogoutButton={true}
                />
                <div>
                    {feedData &&
                        feedData.map((post, index, array) => (
                            <Hexagon key={index}>
                                <TagTop borderColor={post.tag === 'poem' ? "#9B51E0" : "#000"}>&nbsp;</TagTop>
                                <Link to={{
                                    pathname: '/' + post.slug.current
                                }}>
                                    <h3>{parseDate(post.publishedAt)}</h3>
                                </Link>
                                <TagBottom borderColor={post.tag === 'memory' ? "#EB5757" : "#000"}>&nbsp;</TagBottom>
                            </Hexagon>
                        ))}
                </div>
            </FeedContainer>
        </div>
    );
}

export default Home;

const FeedContainer = styled.div`
  margin: 60px auto 32px auto;
  width: 10%;
  text-align: center;

  & .logo {
      width: 80px;
      margin-bottom: 30px;
  }

  & h3 {
      text-align: center;
  }

  & a {
      text-decoration: none;
  }

  @media (max-width: 425px) {
      width: 80%;
  }
`;

const MonthSwitcher = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    & button {
        background: none;
        border: none;
        color: #222;
        font-size: 20px;
    }
`;

const Title = styled.h2`
    width: 100%;
    text-align: center;
    font-family: 'Roboto Mono', monospace;
    font-weight: 100;
    font-size: 20px;
    color: #444;

    @media (max-width: 425px) {
      width: 85%;
  }`;


const Hexagon = styled.div`
    padding: 10% 0 10% 0;
    margin: 20px auto 20px auto;
    width: 50%;
    color: white;
    background: url(${img}) center center no-repeat;
    background-size: 100%;

    @media (max-width: 425px) {
      background-size: 52%;
  }

& h3 {
    font-size: 32px;
    font-weight: 300;

    @media (max-width: 425px) {
    font-size: 24px;
  }
}

& a {
    color: white;
}
`;

const TagTop = styled.span`
    position: relative;
    right: 25px;
    top: 0px;
    height: 3px;
    width: 3px;
    border: 1px solid ${props => props.borderColor};
    border-radius: 10px;
    line-height: 1px;
    font-size: 3px;
    letter-spacing: 2px;
`;

const TagBottom = styled.span`
    position: relative;
    left: 25px;
    bottom: 10px;
    height: 3px;
    width: 3px;
    border: 1px solid ${props => props.borderColor};
    border-radius: 10px;
    line-height: 1px;
    font-size: 3px;
    letter-spacing: 2px;
`;